var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 21.9C22.39 21.9 21.9 22.39 21.9 23C21.9 23.61 22.39 24.1 23 24.1C23.61 24.1 24.1 23.61 24.1 23C24.1 22.39 23.61 21.9 23 21.9ZM23 13C17.48 13 13 17.48 13 23C13 28.52 17.48 33 23 33C28.52 33 33 28.52 33 23C33 17.48 28.52 13 23 13ZM25.19 25.19L17 29L20.81 20.81L29 17L25.19 25.19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebBookmark);
export default __webpack_public_path__ + "static/media/WebBookmark.a981cb2359a5cbfd8e90b795b95add51.svg";
export { ForwardRef as ReactComponent };